import { render, staticRenderFns } from "./WorkIconCheckboxMinus.vue?vue&type=template&id=2c363b7c"
import script from "./WorkIconCheckboxMinus.vue?vue&type=script&lang=js"
export * from "./WorkIconCheckboxMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports